// Copyright (c) 2023, iPivot, Corp.
'use strict'

import axios from 'axios'
import PropTypes from 'prop-types'
import i18next from 'i18next'
import { useEffect, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'

const EulaModal = ({ onAccept, onClose, onCovered }) => {
    const [errorFetchingEula, setErrorFetchingEula] = useState(false)
    const [isFetchingEula, setIsFetchingEula] = useState(true)
    const [eula, setEula] = useState(null)

    useEffect(() => {
        const fetchEula = async () => {
            try {
                const navigatorLanguage = window.navigator.language
                let language = navigatorLanguage

                if (language.indexOf('-') >= 0) {
                    language = navigatorLanguage.substring(0, navigatorLanguage.indexOf('-'))
                }

                let licenseHtml
                try {
                    licenseHtml = (await axios.get(`/oem/license.html`)).data
                } catch (err) {
                    licenseHtml = (await axios.get(`/dist/locales/${language}/license.html`)).data
                }

                setEula(licenseHtml)
                setIsFetchingEula(false)
            } catch (err) {
                setErrorFetchingEula(true)
            } finally {
                setIsFetchingEula(false)
            }
        }

        fetchEula()
    }, [])

    return (
        <Modal show size="lg">
            <Modal.Header>
                <Modal.Title>{i18next.t('eula.end_user_license_agreement_title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isFetchingEula ? (
                    <Spinner />
                ) : errorFetchingEula ? (
                    <div className="text-danger">Failed to fetch EULA</div>
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: eula }} />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    {i18next.t('eula.do_not_accept_button')}
                </Button>
                <Button className="ms-2 me-2" onClick={onCovered}>
                    {i18next.t('eula.covered_under_seperate_agreement_button')}
                </Button>
                <Button onClick={onAccept}>{i18next.t('eula.accept_button')}</Button>
            </Modal.Footer>
        </Modal>
    )
}

EulaModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    onCovered: PropTypes.func.isRequired,
}

export default EulaModal
